import { SWRConfiguration } from 'swr'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { GraphQLError } from '@pylot-data/graphqlFetch'
import { UrlResolverArgs } from '@pylot-data/pylotschema'
import { RequestInit } from '@vercel/fetch'
import { useQuery } from '../use-query'
import { UrlResolveEnum } from '@pylot-data/enums/UrlResolveEnum'
import { urlResolverQuery } from './graphql/urlResolverQuery'

export type UseUrlResolverResponse = {
    resolvedUrl?: ResolvedUrlType | null
    isValidating: boolean
    error?: GraphQLError
}

type UrlResolverType = {
    urlResolver: ResolvedUrlType
}

type ResolvedUrlType = {
    entity_uid: string
    relative_url: string
    redirectCode: number
    type: string
}

export const useUrlResolver = (
    url: string,
    swrOptions?: SWRConfiguration,
    fetchOptions?: RequestInit
): UseUrlResolverResponse => {
    const router = useRouter()
    const { data, error, isValidating } = useQuery<
        UrlResolverArgs,
        UrlResolverType
    >(urlResolverQuery, { url: url }, swrOptions, fetchOptions)

    const redirectUrl = data?.data.urlResolver
    const isFullUrl = redirectUrl?.relative_url?.startsWith('http')

    const resolvedUrl =
        data?.data.urlResolver &&
        data?.data.urlResolver.type === UrlResolveEnum.Custom
            ? data?.data.urlResolver
            : null

    useEffect(() => {
        if (resolvedUrl && resolvedUrl.relative_url) {
            if (isFullUrl) {
                window.location.href = resolvedUrl.relative_url
            } else {
                router.push(resolvedUrl.relative_url)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resolvedUrl])

    return {
        resolvedUrl: resolvedUrl,
        isValidating,
        error
    }
}
